module.exports = __webpack_public_path__ + "static/media/screenshot-view-results.35e31fd2.png";